import "react-app-polyfill/stable";
import { initI18N } from "i18n";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";
import { Spinner, TranslationContextProvider } from "component-library";
import { QueryClient, QueryClientProvider } from "react-query";
import { LaunchDarklyProvider, initSentry } from "shared-services";

import "./index.css";

import { config } from "./config/common";
import { ApplicationContextProvider } from "./context/ApplicationContext";
import { CastingContextProvider } from "./context/CastingApplicationContext";
import { UserContextProvider } from "./context/UserContext";
import { YPApplicationContextProvider } from "./context/YPApplicationContext";
import AppRoutes from "./Routes";

initSentry(null, "joining-pages");
initI18N(["joining"]);

TagManager.initialize({
  gtmId: config.gtm.gtmId,
  events: {
    conversion: "conversion",
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

root.render(
  <Suspense
    fallback={
      <div className="flex justify-center items-center w-screen h-screen">
        <Spinner />
      </div>
    }
  >
    <React.StrictMode>
      <UserContextProvider>
        <LaunchDarklyProvider>
          <ApplicationContextProvider>
            <YPApplicationContextProvider>
              <CastingContextProvider>
                <QueryClientProvider client={queryClient}>
                  <TranslationContextProvider>
                    <AppRoutes />
                  </TranslationContextProvider>
                </QueryClientProvider>
              </CastingContextProvider>
            </YPApplicationContextProvider>
          </ApplicationContextProvider>
        </LaunchDarklyProvider>
      </UserContextProvider>
    </React.StrictMode>
  </Suspense>
);
